import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { authPaths } from '../../constants';
import { UserRolesResolve } from '../../user';
import { PipelineDataResolver } from '../services/pipeline-data.resolver';

@Injectable()
export class LoanSelectorGuard implements CanActivate {
  constructor(
    private router: Router,
    private pipelineDataResolverService: PipelineDataResolver,
    private userRolesResolve: UserRolesResolve
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (state.url.includes('select-loan')) {
      if (route.data && route.data.loans) {
        const excludedStatuses = this.pipelineDataResolverService.closedLoanStages;
        if (route.data.loans.length === 1 && !excludedStatuses.includes(route.data.loans[0].CurrentStage?.StageId)) {
          return this.router.createUrlTree(['pos', 'app', route.data.loans[0].LoanId]);
        } else if (route.data.loans.length === 0) {
          return this.router.createUrlTree(['pos', 'app', 'loan-purpose']);
        }
      } else {
        let nmls = null;
        const path = state.url.split('/');
        if (path.length > 1 && path[1] && !authPaths.includes(path[1])) {
          nmls = path[1];
        }
        let user;
        return this.userRolesResolve.getCurrentUserWithACL(nmls).pipe(
          switchMap((userr) => {
            user = userr;
            return this.pipelineDataResolverService.getPipelines().pipe(
              map((pipelines) => {
                const excludedStatuses = this.pipelineDataResolverService.closedLoanStages;
                const url = state.url.split('/');
                url.pop();
                if (user && user.Loans && user.Loans.length === 1 && !excludedStatuses.includes(user.Loans[0].CurrentStage?.StageId)) {
                  url.push(user.Loans[0].LoanId);
                  return this.router.createUrlTree(url);
                } else if (user && (!user.Loans || user.Loans.length === 0)) {
                  url.push('loan-purpose');
                  return this.router.createUrlTree(url);
                } else {
                  return true;
                }
              })
            );
          })
        );
      }
    }

    return true;
  }
}
